// Shared submit orchestration: collect + validate responses, POST, then
// drive the caller's state setters and publish callbacks. Store-agnostic.
import { postBooking } from "./api.js";
import { formatSlotLabel } from "./format.js";
/**
 * Collect responses for extra fields (skips name/email/rescheduleReason and
 * hidden fields). Returns null if a required extra field is empty so the
 * caller can abort.
 */
export function buildBookingResponses(fields, formValues) {
    const responses = {};
    if (!fields)
        return responses;
    for (const f of fields) {
        if (f.hidden)
            continue;
        if (f.slug === "name" || f.slug === "email" || f.slug === "rescheduleReason")
            continue;
        const trimmed = formValues[f.slug]?.trim() ?? "";
        if (f.required && trimmed === "")
            return null;
        if (trimmed !== "")
            responses[f.slug] = trimmed;
    }
    return responses;
}
/** Returns false if validation aborted before any network call. */
export async function submitBooking(args) {
    const name = (args.formValues["name"] ?? "").trim();
    const email = (args.formValues["email"] ?? "").trim();
    if (!name || !email)
        return false;
    const responses = buildBookingResponses(args.fields, args.formValues);
    if (responses === null)
        return false;
    args.setSubmitting(true);
    args.setBookingError(null);
    const base = args.serviceUrl.replace(/\/+$/, "");
    try {
        const result = await postBooking(base, args.publishableKey, {
            nonce: args.nonce,
            start: args.selectedStart,
            attendee: { name, email, timeZone: args.timeZone },
            responses,
        });
        args.setBookingResult(result);
        args.setSubmitting(false);
        const label = args.selectedStartLabel ?? formatSlotLabel(args.selectedStart);
        args.onCompleted({
            attendee_name: result.attendee_name,
            start: result.start,
            start_label: label,
        });
    }
    catch (err) {
        const reason = err instanceof Error ? err.message : "Booking failed";
        args.setBookingError(reason);
        args.setSubmitting(false);
        args.onFailed({ reason });
    }
    return true;
}
